export default "__VITE_ASSET__qKBMr6QO__"